import request from '../utils/request'
// import { encodeQuery } from '../utils/helperFunctions'
import { FETCH_TYPES } from '../utils/constants'
import { REST_API } from './API_Routes'
import ServiceBase from './ServiceBase'

export default class AuthService extends ServiceBase {
  static async login(body) {
    const token = false
    const option = {
      method: FETCH_TYPES.POST,
      body: body,
    }
    const response = await request(REST_API.LOGIN, option, token)
    return response
  }

  static logout = async () => {
    const option = {
      method: FETCH_TYPES.POST,
    }
    const response = await request(REST_API.LOGOUT, option)
    return response
  }

  static async user_registration_check(body) {
    const token = false
    const option = {
      method: FETCH_TYPES.POST,
      body: body,
    }
    const response = await request(
      REST_API.USER_REGISTRATION_CHECK,
      option,
      token,
    )
    return response
  }

  static async user_login(body) {
    const token = false
    const option = {
      method: FETCH_TYPES.POST,
      body: body,
    }
    const response = await request(REST_API.USER_LOGIN, option, token)
    return response
  }

  static async user_otp_verification(body) {
    const token = false
    const option = {
      method: FETCH_TYPES.POST,
      body: body,
    }
    const response = await request(
      REST_API.USER_OTP_VERIFICATION,
      option,
      token,
    )
    return response
  }

  static async user_password_set(body) {
    const token = false
    const option = {
      method: FETCH_TYPES.POST,
      body: body,
    }
    const response = await request(REST_API.USER_PASSWORD_SET, option, token)
    return response
  }
}
